import { render, staticRenderFns } from "./DevelopersPage.vue?vue&type=template&id=be1597ca"
import script from "./DevelopersPage.vue?vue&type=script&lang=js"
export * from "./DevelopersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports